import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ClientPortalApp } from './core/client-portal/ClientPortalApp';
import { getClientPortalSlug } from './core/client-portal/hostname';
import './styles/index.css';
import './core/i18n'; // Inicializar i18n

/**
 * Entry point for WESTEER Core Frontend.
 */
const rootElement: HTMLElement | null = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Portal de cliente (ej. bahia.sintax.city): árbol de rutas propio, aislado
// de `<App/>` — para cualquier otro hostname, el comportamiento existente
// no cambia en nada.
const portalSlug = getClientPortalSlug(window.location.hostname);

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      {portalSlug ? <ClientPortalApp slug={portalSlug} /> : <App />}
    </Suspense>
  </React.StrictMode>
);
